import { Resizable } from 're-resizable';
import styled from 'styled-components';
import { color } from '@stockbit/ui';
import { assetPrefix } from 'constants/app';

const bgBottom = assetPrefix + '/icon/horizontal.png';

const ResizeIndicator = styled.div`
  width: 100%;
  height: 10px;
  background-image: url(${bgBottom});
  background-color: ${color.aliceBlue};
  background-repeat: no-repeat;
  background-position: 50%;
  border-bottom: 1px solid ${color.gainsboro};
  margin-top: -5px; /* Put indicator inside the box */
  cursor: s-resize;
`;

const Box = styled(Resizable).attrs((props) => ({
  handleComponent: props.handleComponent || {
    bottom: <ResizeIndicator />,
  },
  enable: {
    top: false,
    right: false,
    bottom: true,
    left: false,
    topRight: false,
    bottomRight: false,
    bottomLeft: false,
    topLeft: false,
  },
}))`
  padding-top: 0px;
  z-index: 99;

  > div {
    > div {
      z-index: 99;
    }
  }
`;

export { ResizeIndicator, Box };
